import React from 'react';
import { 
  Package, 
  MapPin, 
  Calendar, 
  DollarSign, 
  Clock, 
  CheckCircle, 
  AlertCircle, 
  X, 
  Edit, 
  Shield, 
  Users,
  ArrowRight,
  Send,
  Star,
  User,
  Timer,
  TrendingUp,
  Repeat,
  Route,
  Weight,
  ShoppingBasket,
  Car,
  PlaneTakeoff,
  Trash
} from 'lucide-react';
import { useThemeColors } from '../theme/ThemeContext';
import { applicationsAPI } from '../services/api';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const ParcelCardSleek = ({
  parcel, 
  showActions, 
  isOwner, 
  onCancel, 
  onDelete, 
  onEdit, 
  onRepost,
  onViewDetails
}) => {
  const colors = useThemeColors();
  const navigate = useNavigate();
  


  const handleCardClick = () => {
    if (!isExpired) {
      navigate(`/parcels/${parcel.id}`);
      
    }
  };
  

  const getStatusColor = (status) => {
    switch (status) {
      case 'posted':
        return { bg: colors.success[50], text: colors.success[700], border: colors.success[200] };
      case 'in_transit':
        return { bg: colors.primary[50], text: colors.primary[700], border: colors.primary[200] };
      case 'delivered':
        return { bg: colors.neutral[50], text: colors.neutral[700], border: colors.neutral[200] };
      case 'cancelled':
        return { bg: colors.error[50], text: colors.error[700], border: colors.error[200] };
      default:
        return { bg: colors.neutral[50], text: colors.neutral[700], border: colors.neutral[200] };
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'posted':
        return <Clock className="h-4 w-4" />;
      case 'in_transit':
        return <Package className="h-4 w-4" />;
      case 'delivered':
        return <CheckCircle className="h-4 w-4" />;
      case 'cancelled':
        return <X className="h-4 w-4" />;
      default:
        return <AlertCircle className="h-4 w-4" />;
    }
  };

  const canApply = parcel.status === 'posted' && !showActions;
  const isExpired = parcel.expires_at 
    ? new Date(parcel.expires_at) < new Date()
    : false;
  const canEdit = isOwner && showActions && ['posted'].includes(parcel.status) && !isExpired;
  const canCancel = isOwner && showActions && ['posted'].includes(parcel.status) && !isExpired;
  const canDelete = isOwner && showActions && (['expired', `cancelled`].includes(parcel.status) || !isExpired
)
  const daysUntilExpiry = parcel.expires_at 
    ? Math.ceil((new Date(parcel.expires_at) - new Date()) / (1000 * 60 * 60 * 24))
    : null;

  const isExpiringSoon = daysUntilExpiry !== null && daysUntilExpiry <= 3;

  const getCategoryEmoji = (category) => {
    switch (category) {
      case 'documents':
        return '📄';
      case 'electronics':
        return '📱';
      case 'clothing':
        return '👕';
      case 'food':
        return '🍔';
      default:
        return '📦';
    }
  };

  const formatValue = (value) => {
    if (!value) return 'N/A';
    const num = parseFloat(value);
    const formattedValue = new Intl.NumberFormat('en-ET', {
      style: 'currency',
      currency: 'ETB',
      maximumFractionDigits: 0
    }).format(num);
    return formattedValue;
  };

  const statusColors = getStatusColor(parcel.status);

  return (
    <div 
      className="group shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer border rounded-2xl"
      style={{ 
        backgroundColor: colors.card, 
        borderColor: colors.border
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = colors.primary[300];
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = colors.border;
      }}
      onClick={handleCardClick}
    >
      {/* Header with gradient background */}
      {/* <div 
        className="relative p-6 text-white"
        style={{
          background: `linear-gradient(to right, ${colors.primary[600]}, ${colors.primary[700]})`
        }}
      >
        <div className="absolute top-4 right-4">
          <span 
            className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border"
            style={{
              backgroundColor: colors.secondary[600],
              borderColor: 'rgba(255, 255, 255, 0.3)',
              backdropFilter: 'blur(8px)'
            }}
          >
            {getStatusIcon(parcel.status)}
            <span className="ml-1 text-xs" style={{ textTransform: 'uppercase' }}>{parcel.status}</span>
          </span>
        </div>

        <div className="flex items-center space-x-4 mb-4">
          <div className="text-3xl">{getCategoryEmoji(parcel.category)}</div>
          <div>
            <h3 className="text-xl font-bold capitalize">{parcel.category}</h3>
            <p className="opacity-90 text-sm">Delivery</p>
          </div>
        </div>

      </div> */}

      {/* Content */}
      <div className="p-6">
        {/* Route */}
        <div className="mb-6">
          <div className=" items-center justify-center">
            <div className="flex-1">
              <div className="flex items-center" style={{ color: colors.text.secondary }}>
                <MapPin className="h-4 w-4 mr-2" style={{ color: colors.success[500] }} />
                <div>
                  <p className="text-xs uppercase tracking-wide" style={{ color: colors.text.tertiary }}>From</p>
                  <p className="font-semibold truncate" style={{ color: colors.text.primary }}>{parcel.pickup}</p>
                  <p className="text-xs truncate" style={{ color: colors.text.secondary }}>{parcel.pickup_country}</p>
                </div>
              </div>
            </div>
            
            <div className="flex-1 text-center px-4">
              <div className="flex items-center justify-center" style={{ color: colors.text.tertiary }}>
                <div style={{ width: '32px', height: '1px', backgroundColor: colors.border }}></div>
                <ArrowRight className="h-4 w-4 mx-2" />
                <div style={{ width: '32px', height: '1px', backgroundColor: colors.border }}></div>
              </div>
            </div>
            
            <div className="flex-1">
              <div className="flex items-center justify-end" style={{ color: colors.text.secondary }}>
                <div className="text-right">
                  <p className="text-xs uppercase tracking-wide" style={{ color: colors.text.tertiary }}>To</p>
                  <p className="font-semibold truncate" style={{ color: colors.text.primary }}>{parcel.dropoff}</p>
                  <p className="text-xs truncate" style={{ color: colors.text.secondary }}>{parcel.dropoff_country}</p>
                </div>
                <MapPin className="h-4 w-4 ml-2" style={{ color: colors.error[500] }} />
              </div>
            </div>
            
            <hr className="my-4" style={{ border: '0.5px broken', borderColor: colors.border }} />
            

          </div>
        </div>

        {/* Key metrics */}
        <div className="grid grid-cols-2 gap-2 mb-2">
          {/* <div className="text-center p-1 rounded-xl" style={{ backgroundColor: colors.neutral[50] }}>
            <Weight className="h-4 w-4 mx-auto mb-1" style={{ color: colors.primary[500] }} />
            <p className="text-xs" style={{ color: colors.text.tertiary }}>Weight</p>
            <p className="font-bold" style={{ color: colors.text.primary }}>{parcel.weight_kg} kg</p>
          </div>
          
          <div className="text-center p-1 rounded-xl" style={{ backgroundColor: colors.neutral[50] }}>
            <ShoppingBasket className="h-4 w-4 mx-auto mb-1" style={{ color: colors.success[500] }} />
            <p className="text-xs" style={{ color: colors.text.tertiary }}>
              Purchase
            </p>
            <p className="font-bold" style={{ color: colors.text.primary }}>
              {formatValue(parcel.purchase_price)}
            </p>
          </div>
          
          <div className="text-center p-1 rounded-xl" style={{ backgroundColor: colors.neutral[50] }}>
            <DollarSign className="h-4 w-4 mx-auto mb-1" style={{ color: colors.success[500] }} />
            <p className="text-xs" style={{ color: colors.text.tertiary }}>
              Guaranteed
            </p>
            <p className="font-bold" style={{ color: colors.text.primary }}>
              {formatValue(parcel.declared_value)}
            </p>
          </div> */}
          
          <div className="text-center p-1 rounded-xl" style={{ backgroundColor: colors.neutral[50] }}>
            <PlaneTakeoff className="h-4 w-4 mx-auto mb-1" style={{ color: colors.success[500] }} />
            <p className="text-xs" style={{ color: colors.text.tertiary }}>
              Delivery
            </p>
            <p className="font-bold" style={{ color: colors.text.primary }}>
              {formatValue(parcel.max_delivery_price)}
            </p>
          </div>
          
          <div 
            className="text-center p-1 rounded-xl" 
            style={{ 
              backgroundColor: isExpiringSoon ? colors.error[50] : colors.neutral[50]
            }}
          >
            <Timer 
              className="h-4 w-4 mx-auto mb-1" 
              style={{ color: isExpiringSoon ? colors.error[500] : colors.warning[500] }} 
            />
            <p className="text-xs" style={{ color: colors.text.tertiary }}>Expires</p>
            <p 
              className="font-bold" 
              style={{ 
                color: isExpiringSoon ? colors.error[600] : colors.text.primary 
              }}
            >
              {daysUntilExpiry !== null ? `${daysUntilExpiry}d` : 'N/A'}
            </p>
          </div>
        </div>
        <hr className="my-4" style={{ border: '0.5px broken', borderColor: colors.border }} />

        {/* Description */}
        {/* {parcel.notes && (
          <div className="mb-6">
            <p className="text-sm line-clamp-2" style={{ color: colors.text.secondary }}>{parcel.notes}</p>
          </div>
        )} */}

        {/* Special badges */}
        <div className="flex flex-wrap gap-1 my-5">
            
          {(!parcel.guaranteed_delivery && !parcel.purchased) && (
            <span 
              className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border"
              style={{
                backgroundColor: `${colors.neutral[600]}`,
                color: colors.neutral[100],
                borderColor: `${colors.neutral[600]}`
              }}
            >
              <Shield className="h-3 w-3 mr-1" />
              Standard
            </span>
          )}
          {parcel.guaranteed_delivery && (
            <span 
              className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border"
              style={{
                backgroundColor: `${colors.warning[600]}`,
                color: colors.warning[100],
                borderColor: `${colors.warning[600]}`
              }}
            >
              <Shield className="h-3 w-3 mr-1" />
              Guaranteed
            </span>
          )}
          {parcel.purchased && (
            <span 
              className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border"
              style={{
                backgroundColor: `${colors.success[500]}`,
                color: colors.success[100],
                borderColor: `${colors.success[500]}`
              }}
            >
              <Package className="h-3 w-3 mr-1" />
              Purchased
            </span>
          )}
          {parcel.applications_count && (
            <span 
              className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border"
              style={{
                backgroundColor: `${colors.secondary[600]}`,
                color: colors.secondary[100],
                borderColor: `${colors.secondary[600]}`
              }}
            >
              <Users className="h-3 w-3 mr-1" />
              {parcel.applications_count}
              {/* {parcel.applications_count} Application{parseInt(parcel.applications_count) !== 1 ? 's' : ''} */}
            </span>
          )}
        </div>

        {/* Action Buttons */}
        {(canEdit || canCancel || canDelete) && (
          <div className="flex gap-2 mt-4">
            {canEdit && (
              <button
                // disabled={parseInt(parcel.applications_count) > 0}
                onClick={(e) => {
                  e.stopPropagation();
                  if (onEdit) onEdit(parcel);
                }}
                className="flex-1 flex items-center justify-center px-3 py-2 text-sm font-medium rounded-lg border border-theme-primary text-theme-primary hover:bg-theme-primary hover:text-white transition-colors"
                style={{
                  borderColor: colors.primary[500],
                  color: colors.primary[600]
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = colors.primary[500];
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = colors.primary[600];
                }}
              >
                <Edit className="h-4 w-4 mr-1" />
                Edit
              </button>
            )}
            {canCancel && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (onCancel) onCancel(parcel);
                }}
                className="flex-1 flex items-center justify-center px-3 py-2 text-sm font-medium rounded-lg border border-theme-secondary text-theme-secondary hover:bg-theme-error hover:text-white transition-colors"
                style={{
                  borderColor: colors.warning[500],
                  color: colors.warning[600]
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = colors.warning[500];
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = colors.warning[600];
                }}
              >
                <X className="h-4 w-4 mr-1" />
                Cancel
              </button>
            )}
            {canDelete && !canCancel && !canEdit &&(
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (onDelete) onDelete(parcel);
                }}
                className="flex-1 flex items-center justify-center px-3 py-2 text-sm font-medium rounded-lg border border-theme-error text-theme-error hover:bg-theme-error hover:text-white transition-colors"
                style={{
                  borderColor: colors.error[500],
                  color: colors.error[600]
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = colors.error[500];
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = colors.error[600];
                }}
              >
                <Trash className="h-4 w-4 mr-1" />
                Delete
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ParcelCardSleek;
